import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import type { Documents as DocumentsType } from '../types/content'
import { FileText, Download } from './Icons'

interface DocumentsProps {
  data: DocumentsType
}

export default function Documents({ data }: DocumentsProps) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section id="documents" className="section bg-dark-secondary" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="section-header"
        >
          <h2 className="section-title">{data.title}</h2>
          <p className="section-subtitle">{data.subtitle}</p>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4">
          {data.documents.map((doc, index) => (
            <motion.div
              key={doc.id}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
              className="flex gap-6 p-6 bg-dark border border-border rounded-xl transition-all duration-300 hover:border-primary"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-xl text-primary shrink-0">
                <FileText className="w-8 h-8" />
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-semibold mb-2">{doc.title}</h3>
                <p className="text-sm text-gray-400 mb-4">{doc.description}</p>

                <div className="flex items-center gap-4">
                  <span className="px-2 py-1 text-xs font-medium bg-dark-tertiary rounded text-gray-400">
                    {doc.type === 'info' ? 'Реестр' : doc.type}
                  </span>
                  {doc.url && doc.type !== 'info' && (
                    <a
                      href={doc.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-sm text-primary hover:opacity-80 transition-opacity"
                    >
                      <Download className="w-4 h-4" />
                      Скачать
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
